/*
 * action types
 */
export const SET_SNACKBAR = 'SET_SNACKBAR'

/*
 * action creators
 */

export default function snackBar(payload) {
  return {
    payload,
    type: SET_SNACKBAR,
  }
}
